import clsx from 'clsx';

import { InputOverrideClassNames } from '../textinput';
import { TextAreaStyleProps } from '../types';

import textAreaClasses from './TextArea.module.css';

export const TextAreaOverrideClassnames = (props: TextAreaStyleProps) => {
  const { size, borderless } = props;

  const classes = InputOverrideClassNames({ size });

  return {
    ...classes,
    input: clsx(textAreaClasses.input, {
      [textAreaClasses.withoutBorder]: borderless
    })
  };
};
